import { render, staticRenderFns } from "./card-table.vue?vue&type=template&id=0da6ec1c&"
import script from "./card-table.vue?vue&type=script&lang=js&"
export * from "./card-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports